import { useState, useCallback } from 'react';
import { cloneDeep } from 'lodash-es';

// base相同结构数据
const baseData = {
  latLon: { lat: '', lon: '' }, // wgs84_location
  latLonBaidu: { lat: '', lon: '' },
  latLonGcj: { lat: '', lon: '' }, // location
  name: '', // 地名  - name
  addr: '', // 地址  - address
  cityId: 0, // 城市ID
  cityName: '', // 城市名  - city
  districtName: '', // 区域 - area
  houseNumber: '', // 门牌号
  contactsName: '', // 联系人名
  contactsPhoneNo: '', // 联系人号码
  // 下面部分感觉用不上。先备注
  // poiSource: '', // poi来源（search、rgeo-baidu）- apiType
  uid: '',
  // adcode: '',
};

// 首页地址列表
const initState = {
  ...baseData,
  // 下面部分感觉用不上。先备注
  poiId: '', // poi_id  - uid
  typecode: '', // POI类型编码 - typecode
  // placeType: '', // 地地址来源类型 1—推荐地址 2—常用路线 3—推动地图 4—点击归位 5—实时检索 6—历史地址 7—当前位置 8—常用地址
  // addrSource: '',
  // distanceType: '',
  // actionType: '',
  // isRequestRec: '',
};

// 常用地址结构
const initCommAddrState = {
  addrInfo: {
    ...baseData,
    // 下面部分感觉用不上。先备注
    wgsSource: '',
    locationSource: '',
  },
  id: 0,
  isEdit: false, // 是否编辑状态
};
// 历史订单接口不带s，下单带s，两个值一样。
const parseBase = (sendVal: any) => {
  return {
    lat_lon: sendVal.latLon,
    lat_lon_baidu: sendVal.latLonBaidu,
    lat_lon_gcj: sendVal.latLonGcj,
    name: sendVal.name,
    addr: sendVal.addr,
    city_id: sendVal.cityId,
    city_name: sendVal.cityName,
    district_name: sendVal.districtName,
    house_number: sendVal.houseNumber,
    contacts_name: sendVal.contactsName,
    contacts_phone_no: sendVal.contactsPhoneNo,
    contact_name: sendVal.contactsName,
    contact_phone_no: sendVal.contactsPhoneNo,
    uid: sendVal.uid,
    poi_id: sendVal.poiId,
    // adcode: sendVal.adcode,
    // wgs_source: sendVal.wgsSource,
    // location_source: sendVal.locationSource,
  };
};

// 驼峰转下划线数据 常用地址提交数据结构
// 常用地址提交数据结构
// {
//   id,
//   addrInfo,
//   isEdit,
// }
export const getPostDataCommAddr = (sendVal: any) => {
  return {
    addr_info: {
      ...parseBase(sendVal),
    },
  };
};

// 驼峰转下划线数据 下单数据结构
export const getPostDataAddr = (sendVal: any) => {
  return {
    ...parseBase(sendVal),
  };
};

export default function OrderCenterSameCityRoute() {
  const [addrInit] = useState({ ...cloneDeep(initState) }); // 初始化的首页地址数据
  // 路线数据
  const [addrLists, setAddrLists] = useState([
    { ...cloneDeep(initState), id: Date.now() },
    { ...cloneDeep(initState), id: Date.now() + 1 },
  ]);
  // 路线数据-再来一单暂存
  const [addrListsFromOrderAgain, setAddrListsFromOrderAgain] = useState([]);
  const [canNext, setCanNext] = useState<boolean[]>([]); // 校验结果集合
  const setAddrListsMod = useCallback((val) => {
    setAddrLists(val);
  }, []);
  const setCanNextMod = useCallback(
    (val) => {
      setCanNext([...canNext, val]);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [canNext]
  );
  const getPostDataAddrMod = useCallback(() => {
    const tmpData = addrLists.map((oItem) => {
      return getPostDataAddr(oItem);
    });
    return tmpData;
  }, [addrLists]);
  // 重置发货地址
  const setResetStartAddrMod = useCallback(() => {
    const tmpAddr = cloneDeep(addrLists);
    tmpAddr[0] = { ...cloneDeep(initState), id: Date.now() };
    setAddrLists(tmpAddr);
  }, [addrLists]);
  // 清空重设地址
  const reset = useCallback(() => {
    setAddrLists([
      { ...cloneDeep(initState), id: Date.now() },
      { ...cloneDeep(initState), id: Date.now() + 1 },
    ]);
  }, []);
  // 再来一单
  const set = useCallback((val) => {
    const tmpData = val.map((oItem: any, index: number) => {
      const poiId = oItem?.poiId || oItem?.poi_id || '';
      return {
        latLon: oItem.latLon,
        latLonBaidu: oItem.latLonBaidu,
        latLonGcj: oItem.latLonGcj,
        name: oItem.name,
        addr: oItem.addr,
        cityId: oItem.cityId,
        cityName: oItem.cityName,
        districtName: oItem.districtName,
        houseNumber: oItem.houseNumber,
        contactsName: oItem.contactsName,
        contactsPhoneNo: oItem.contactsPhoneNo,
        contactName: oItem.contactsName,
        contactPhoneNo: oItem.contactsPhoneNo,
        // poiSource: oItem.poiSource,
        uid: poiId,
        poiId,
        // adcode: '',
        // wgsSource: '',
        // locationSource: '',
        // typecode: '',
        id: Date.now() + index,
        status: oItem.status ?? 200,
      };
    });
    setAddrListsFromOrderAgain(tmpData);
  }, []);
  const setOnceAgain = useCallback((val) => {
    setAddrLists(val);
  }, []);
  // 清除某一项poi值

  // 常用地址
  const [commAddrInit] = useState({ ...cloneDeep(initCommAddrState) }); // 初始化的常用地址数据
  const [addrBookShow, setAddrBookShow] = useState(false); // 常用地址弹窗
  const [addrBookIndex, setAddrBookIndex] = useState(-1); // 常用地址弹窗 对象索引
  const [commAddrLists, setCommAddrLists] = useState([]);
  const [selectedIndex, setSelectIndex] = useState(-1); // 下单地址的选中值 - 常用地址回填索引

  const setCommAddrListsMod = useCallback((val) => {
    setCommAddrLists(val);
  }, []);
  const setAddrBookShowMod = useCallback((val) => {
    setAddrBookShow(val);
  }, []);
  const setSelectIndexMod = useCallback((val) => {
    setSelectIndex(val);
  }, []);

  // 接口提交数据结构
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getPostData = {
    lat_lon: { lat: '', lon: '' }, // wgs84_location
    lat_lon_baidu: { lat: '', lon: '' },
    lat_lon_gcj: { lat: '', lon: '' }, // location
    name: '', // 地名  - name
    addr: '', // 地址  - address
    city_id: 0, // 城市ID
    city_name: '', // 城市名  - city
    district_name: '', // 区域 - area
    house_number: '', // 门牌号
    contact_name: '', // 联系人名
    contacts_phone_no: '', // 联系人号码
    // 下面部分感觉用不上。先备注
    poi_id: '', // poi_id  - uid
    poi_source: '', // poi来源（search、rgeo-baidu）- apiType
    typecode: '', // POI类型编码 - typecode
    // place_type: '', // 地地址来源类型 1—推荐地址 2—常用路线 3—推动地图 4—点击归位 5—实时检索 6—历史地址 7—当前位置 8—常用地址
    // addr_source: '',
    // distance_type: '',
    // action_type: '',
    // is_request_rec: '',
  };

  return {
    addrInit,
    addrLists,
    setAddrLists,
    addrListsFromOrderAgain,
    setAddrListsMod,
    commAddrInit,
    addrBookShow,
    setAddrBookShowMod,
    addrBookIndex,
    setAddrBookIndex,
    commAddrLists,
    setCommAddrListsMod,
    initCommAddrState,
    selectedIndex,
    setSelectIndexMod,
    canNext,
    setCanNextMod,
    getPostDataAddrMod,
    setResetStartAddrMod,
    set,
    setOnceAgain,
    reset,
  };
}
